import { Component, inject } from '@angular/core';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {
  private notificationService = inject(NotificationService);
  alerts = this.notificationService.alerts;

  dismiss(id: number): void {
    this.notificationService.dismiss(id);
  }
}
